import { candidateRequests } from "api/candidateApi";
import React from "react";
import { ReferenceField, SimpleShowLayout, TextField } from "react-admin";
import { CampaignSubTypeLabels, CampaignSubTypePaths } from "utils/constants";

const ChildCampaignField = ({ childCampaignSubTypeId }) => {
  const inputLabel = CampaignSubTypeLabels[childCampaignSubTypeId] || "Кампания";
  const subPath = CampaignSubTypePaths[childCampaignSubTypeId] || "not-found";

  return (
    <SimpleShowLayout sx={{ padding: 0 }}>
      <ReferenceField
        label={inputLabel}
        source="childCampaignId"
        emptyText="Няма"
        reference={candidateRequests.getCampaignsSelect()}
        link={record => `/${candidateRequests.campaignByType(subPath)}/${record.id}/show`}
      >
        <TextField
          source="nameBg"
          label={inputLabel}
        />
      </ReferenceField>
    </SimpleShowLayout>
  );
};

export default ChildCampaignField;
